// Third Party
import _ from 'lodash';

import { Feature } from '@contexts/search-context';

interface CategorizedFeatures {
  label: string;
  features: Feature[];
}

export const categorizeAndSortFeatures = (
  features: Feature[]
): CategorizedFeatures[] => {
  const categorizedFeatures: CategorizedFeatures[] = [
    {
      label: 'Popular',
      features: [],
    },
  ];

  // Decorate above object with new categories.
  features.forEach((feature) => {
    if (feature.promoted) {
      const i = _.findIndex(
        categorizedFeatures,
        (category) => category.label === 'Popular'
      );
      categorizedFeatures[i].features.push(feature);
    } else {
      const categoryIndex = _.findIndex(
        categorizedFeatures,
        (cat) => cat.label === feature.categoryName
      );
      // If category exists in our object, add features.
      if (categoryIndex > -1) {
        categorizedFeatures[categoryIndex].features.push(feature);
      }
      // Otherwise create new category object initialized with feature.
      else {
        categorizedFeatures.push({
          label: feature.categoryName,
          features: [feature],
        });
      }
    }
  });

  return categorizedFeatures.filter((categorizedFeature) => {
    return categorizedFeature.features.length > 0;
  });
};
